// extracted by mini-css-extract-plugin
module.exports = {"tags":"propertyCardTags_tags__WVPf1","bottomTags":"propertyCardTags_bottomTags__3PRfM","tag":"propertyCardTags_tag__2EufI","featuredTag":"propertyCardTags_featuredTag__tv-AC","typeText":"propertyCardTags_typeText__1c8Rj","type":"propertyCardTags_type__1749u"};
    if(module.hot) {
      // 1744882461083
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  